import { gql } from "@apollo/client";

export const GET_COUNTRY_CODE = gql`
    query countryCodes {
        countryCodes {
            id
            code
            name
            currency
            taxLabel
        }
    }
`;